/** 1×1 transparent GIF: the <img> src placeholder when an image URL is missing. */
export const blankImg = 'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7';
